'use client'

import { Breakpoints } from '@fukku/styles/breakpoints'
import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'
import { getPointOfInterest } from '../../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../../Shared/BannerImage/BannerImage'

type LineBannerImageProps = {
	readonly image: PointOfInterestImage
	readonly priority?: boolean
}

const ASPECT_RATIO_WIDTH = 7
const ASPECT_RATIO_HEIGHT = 5
const ASPECT_RATIO = ASPECT_RATIO_WIDTH / ASPECT_RATIO_HEIGHT

export function LineBannerImage({
	image,
	priority = false,
}: LineBannerImageProps) {
	const lineBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => width / ASPECT_RATIO
	)

	return (
		<BannerImage
			image={image}
			sizes={`(min-width: ${Breakpoints.medium}px) 47vw, 90vw`}
			imageLoader={lineBannerImageLoader}
			priority={priority}
		/>
	)
}
